import { StrictMode, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { IconProvider } from "@ant-design/icons";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import { StyleProvider } from "antd-style";
import ReactDOM from "react-dom/client";

import { RumBootstrap } from "@av/apps/common-apps/platform/components/RumBootstrap";
import { App as AntApp } from "@av/components/atoms/app/App";
import { RootHomeSkeleton } from "./components/templates/layouts/RootHomeSkeleton";
import { rootTheme } from "./config/antdRootTheme";
import { getCspNonce } from "./config/csp-nonce";
import { RootRoutes } from "./routes/RootRoutes";
import "antd/dist/reset.css";
import "./global.css";
import "./config/i18n/i18n-bundle";

const root = ReactDOM.createRoot(document.getElementById("root")!);

const queryClient = new QueryClient();
const cspNonce = getCspNonce();

root.render(
  <StrictMode>
    <StyleProvider nonce={cspNonce}>
      <IconProvider value={{ csp: { nonce: cspNonce } }}>
        <ConfigProvider theme={rootTheme} csp={{ nonce: cspNonce }}>
          <Suspense fallback={<RootHomeSkeleton zIndex={1} />}>
            <AntApp message={{ maxCount: 1 }}>
              <QueryClientProvider client={queryClient}>
                <RumBootstrap />
                <BrowserRouter>
                  <RootRoutes />
                </BrowserRouter>
              </QueryClientProvider>
            </AntApp>
          </Suspense>
        </ConfigProvider>
      </IconProvider>
    </StyleProvider>
  </StrictMode>
);
